{
  "alerts": {
    "edit": "Editar alerta",
    "new": "Crear alerta",
    "navigation_title": "Alertas",
    "alert_info": "Información de la alerta",
    "go_to_index": "Regresar a las alertas",
    "list_title": "Alertas",
    "title": "Alertas",
    "config_page_title": "Configuración de la alerta",
    "monitor_page_title": "Monitorear alerta",
    "config_page_breadcrumb": "Editar",
    "monitor_page_breadcrumb": "Monitorear",
    "create_new": "Crear alerta",
    "create_simple_alert": "Alerta",
    "create_group_alert": "Alerta de grupo",
    "create_new_group_alert": "Crear nueva alerta de grupo",
    "open_monitor": "Eventos",
    "edit_configuration": "Configuración",
    "create_configuration": "Crear configuración",
    "triggered_never": "Nunca",
    "subscribers": "Suscriptores",
    "event_graph": "Gráfico de Eventos",
    "manage_alerts": "Administrar alertas",
    "create_condition": "+ Agregar condición",
    "conditions_type_help_text": "* Seleccione el tipo entre las condiciones",
    "conditions_type_help_tooltip": "La alerta se activará en caso de :\n<ul id='tooltip_conditions'>\n<li><b>Y</b> si todas las condiciones son ciertas</li>\n<li><b>O</b> si alguna condición es verdadera</li>\n</ul>",
    "events": {
      "empty_nodes": "No hay nodos accesibles para esta alerta",
      "duration_hm_tooltip": "%{date}<br />%{duration}",
      "duration_hm_day_tooltip": "%{date}<br />24 horas",
      "triggered_hm": "cambiar el estado de la alerta",
      "triggered_hm_plural": "cambios en el estado de la alerta",
      "download_csv": "Descargar CSV",
      "showing": "Mostrando",
      "prev_month": "Mes anterior",
      "next_month": "Próximo mes",
      "reset_date_selection": "Anular la selección de la fecha"
    },
    "durations": {
      "empty_list": "No hay cambios en el estado de la alerta",
      "total": "Duración total",
      "triggered": "Activado",
      "duration": "Duración"
    },
    "select_nodes": "Seleccionar nodo",
    "select_subscriptions": "Seleccionar suscriptor",
    "empty_subscribers": "Niguno",
    "select_sensor": "Seleccionar sensor",
    "select_param": "Seleccionar parámetro",
    "select_timerange": "Seleccionar periodo",
    "select_func": "Seleccionar comparador",
    "nodes_help_text": "Las siguientes condiciones se aplican a cada nodo de forma independiente",
    "activation_period": "Periodo de activación",
    "message_help_text_remaining": "Caracteres restantes:",
    "notification_method_titles": {
      "email_sms": "Se enviarán un SMS y un correo electrónico cuando se active la alerta",
      "sms": "Se enviará un SMS cuando se active la alerta",
      "email": "El correo electrónico se enviará cuando se active la alerta"
    },
    "tooltips": {
      "deactivation_ts": "Fecha de desactivación: cuando esta alerta se vuelva inactiva y se detenga la supervisión",
      "activation_ts": "Fecha de activación: cuando esta alerta se active y se inicie la supervisión",
      "reactivation_time_ms": "Retraso entre dos notificaciones consecutivas",
      "notification_level": "Con base en esta selección y en el nivel de notificaciones privadas, el usuario recibirá una notificación cuando se active la alerta"
    },
    "rules": "Condiciones",
    "ref": "Referencia",
    "refs": "Referencias",
    "empty_rules": "No hay condiciones",
    "empty_nodes": "No hay nodos",
    "empty_subscriptions": "No hay suscriptores",
    "empty_comparator": "Seleccionar comparador",
    "controls": {
      "share": "Compartir",
      "activate": "Activar",
      "deactivate": "Desactivar"
    },
    "validation": {
      "nodes": "debe añadirse al menos un nodo",
      "conditions": "debe añadirse al menos una condición",
      "subscriptions": "debe añadirse al menos un suscriptor",
      "references_not_used": "Las referencias que no se utilicen en ninguna condición serán removidas",
      "some_editing": "Hay filas bajo edición. No es posible guardarlas hasta que no estén terminadas"
    },
    "success": {
      "deleted": "La alerta se eliminó exitosamente"
    },
    "notification_methods": {
      "email_sms": "Correo electrónico y SMS",
      "sms": "SMS",
      "email": "Correo electrónico"
    },
    "manage_actions": {
      "delete": "Eliminar",
      "delete_past": "eliminado",
      "activate": "Activar",
      "activate_past": "activado",
      "deactivate": "Desactivar",
      "deactivate_past": "desactivado"
    },
    "manage_dialog": {
      "success": "Las alertas han sido %{action} exitosamente",
      "error": "Ocurrió un error, inténtelo de nuevo más tarde o póngase en contacto con el soporte de Netronix"
    },
    "errors": {
      "not_found": "La alerta no es válida",
      "no_action": "No existe tal acción de alerta %{type}",
      "unknown_notification": "Método de notificación desconocido"
    },
    "statuses": {
      "deactivated": "Desactivado",
      "resolved": "Resuelto",
      "active": "Activo",
      "idle": "Inactivo"
    },
    "states": {
      "idle": "Inactivo",
      "resolved": "Resuelto",
      "active": "Activo",
      "deactivated": "Desactivado",
      "activated": "Activado"
    },
    "references": {
      "add_new_plus": "+ Agregar referencia",
      "add_new": "Agregar referencia"
    },
    "monitor": {
      "basic_info": {
        "name": "Nombre",
        "owner": "Propietario",
        "message": "Mensaje",
        "notification_type": "Tipo de notificación"
      },
      "actions": {
        "chart": "Gráfico",
        "table_data": "Datos de tabla"
      },
      "range": {
        "keep_time_range": "Mantener rango de tiempo entre alertas"
      },
      "table": {
        "duration": "Duración",
        "state_changes": "Cambios de estado",
        "total_duration": "Duración total",
        "total_state_changes": "Cambios de estado totales",
        "condition_status": {
          "poor": "Deficiente",
          "good": "Bueno"
        }
      }
    }
  },
  "conditions": {
    "expressions": {
      "eq": "=",
      "neq": "≠",
      "lt": "<",
      "lte": "≤",
      "gt": ">",
      "gte": "≥",
      "eq_title": "igual a (=)",
      "neq_title": "not equal to (≠)",
      "lt_title": "menor que (<)",
      "lte_title": "menor o igual a (≤)",
      "gt_title": "mayor que (>)",
      "gte_title": "mayor o igual a (≥)",
      "abs": "ABS",
      "abs_title": "ABS",
      "min": "MIN",
      "min_title": "Mínimo",
      "max": "MAX",
      "max_title": "Máximo",
      "avg": "PROM.",
      "avg_title": "Promedio",
      "diff": "DIF.",
      "diff_title": "Diferencia",
      "sum": "SUM",
      "sum_titlte": "Sum",
      "scale": "Escala",
      "scale_titlte": "Escala",
      "link": "Vinculado",
      "link_title": "Vinculado"
    },
    "add_condition": "Agregar condición",
    "conditions_or": "Agregar condición (O)",
    "add_condition_or": "Agregar condición (Y)",
    "no_conditions": "No hay condiciones"
  }
}